<template>
  <section class="sub_contents_wrap">
    <form modelAttribute="user" method="post" name="userForm" id="userForm">
      <input type="hidden" aname="emailAddress" id="emailAddress" value="" />
      <input type="hidden" name="displayName" id="displayName" value="" />
      <input type="hidden" name="flag" id="flag" value="" />

      <div class="find_info_box">
        <h3>{{ $t("account.findpw") }}</h3>
        <div class="find_info_inner fi_pw_inner">
          <div class="fi_left">
            {{ $t("account.findpwcontent1") }}<br />
            {{ $t("account.findpwcontent2") }}
          </div>
          <div class="fi_right">
            <input
              type="text"
              id="userId"
              name="loginId"
              class="bg-white"
              title="User ID"
              :placeholder="$t('account.userid')"
              v-model="user.loginId"
            />
            <select class="select_phone bg-white" v-model="user.mobileTelCountry">
              <option value="">선택안함</option>
              <option value="233">+233 가나</option>
              <option value="241">+241 가봉</option>
              <option value="592">+592 가이아나</option>
              <option value="220">+220 감비아</option>
              <option value="502">+502 과테말라</option>
              <option value="1671">+1 671 괌</option>
              <option value="1473">+1 473그레나다</option>
              <option value="30">+30 그리스</option>
              <option value="224">+224 기니</option>
              <option value="245">+245 기니비사우</option>
              <option value="264">+264 나미비아</option>
              <option value="674">+674 나우루</option>
              <option value="234">+234 나이지리아</option>
              <option value="672">+672 남극,오스트레일리아의외</option>
              <option value="27">+27 남아프리카공화국</option>
              <option value="31">+31 네덜란드</option>
              <option value="599">+599 네덜란드령보네르</option>
              <option value="297">+297 네덜란드령아루바</option>
              <option value="977">+977 네팔</option>
              <option value="47">+47 노르웨이</option>
              <option value="64">+64 뉴질랜드</option>
              <option value="683">+683 뉴질랜드령니우에</option>
              <option value="690">+690 뉴질랜드령토켈라우제도</option>
              <option value="227">+227 니제르</option>
              <option value="505">+505 니카라과</option>
              <option value="82">+82 대한민국</option>
              <option value="45">+45 덴마크</option>
              <option value="299">+299 덴마크령그린란드</option>
              <option value="298">+298 덴마크령페로제도</option>
              <option value="1809">+1 809 도미니카공화국</option>
              <option value="1829">+1 829 도미니카공화국 2</option>
              <option value="1849">+1 849 도미니카공화국 3</option>
              <option value="49">+49 독일</option>
              <option value="670">+670 동티모르</option>
              <option value="856">+856 라오스</option>
              <option value="231">+231 라이베리아</option>
              <option value="371">+371 라트비아</option>
              <option value="7">+7 러시아/카자흐스탄</option>
              <option value="961">+961 레바논</option>
              <option value="266">+266 레소토</option>
              <option value="40">+40 루마니아</option>
              <option value="352">+352 룩셈부르크</option>
              <option value="250">+250 르완다</option>
              <option value="218">+218 리비아</option>
              <option value="370">+370 리투아니아</option>
              <option value="423">+423 리히텐슈타인</option>
              <option value="261">+261 마다가스카르</option>
              <option value="692">+261 마셜제도공화국</option>
              <option value="691">+691 마이크로네시아연방</option>
              <option value="853">+853 마카오</option>
              <option value="389">+389 마케도니아공화국</option>
              <option value="265">+265 말라위</option>
              <option value="60">+60 말레이시아</option>
              <option value="223">+223 말리</option>
              <option value="52">+52 멕시코</option>
              <option value="377">+377 모나코</option>
              <option value="212">+212 모로코</option>
              <option value="230">+230 모리셔스</option>
              <option value="222">+222 모리타니아</option>
              <option value="258">+258 모잠비크</option>
              <option value="382">+382 몬테네그로</option>
              <option value="373">+373 몰도바</option>
              <option value="960">+960 몰디브</option>
              <option value="356">+356 몰타</option>
              <option value="976">+976 몽골</option>
              <option value="1">+1 미국/캐나다</option>
              <option value="1670">+1 670 미국령북마리아나제도</option>
              <option value="95">+95 미얀마</option>
              <option value="678">+678 바누아투</option>
              <option value="973">+973 바레인</option>
              <option value="1246">+1 246 바베이도스</option>
              <option value="1242">+1 242 바하마</option>
              <option value="880">+880 방글라데시</option>
              <option value="229">+229 베냉</option>
              <option value="58">+58 베네수엘라</option>
              <option value="84">+84 베트남</option>
              <option value="32">+32 벨기에</option>
              <option value="375">+375 벨라루스</option>
              <option value="501">+501 벨리즈</option>
              <option value="387">+387 보스니아헤르체고비나</option>
              <option value="267">+267 보츠와나</option>
              <option value="591">+591 볼리비아</option>
              <option value="257">+257 부룬디</option>
              <option value="226">+226 부르키나파소</option>
              <option value="975">+975 부탄</option>
              <option value="359">+359 불가리아</option>
              <option value="55">+55 브라질</option>
              <option value="673">+673 브루나이</option>
              <option value="685">+685 사모아</option>
              <option value="966">+966 사우디아라비아</option>
              <option value="378">+378 산마리노</option>
              <option value="239">+239 상투메프린시페</option>
              <option value="221">+221 세네갈</option>
              <option value="381">+381 세르비아</option>
              <option value="248">+248 세이셀</option>
              <option value="1784">+1 784 세인트빈센트그레나딘</option>
              <option value="252">+252 소말리아</option>
              <option value="677">+677 솔로몬제도</option>
              <option value="249">+249 수단</option>
              <option value="597">+597 수리남</option>
              <option value="94">+94 스리랑카</option>
              <option value="268">+268 스와질랜드</option>
              <option value="46">+46 스웨덴</option>
              <option value="41">+41 스위스</option>
              <option value="34">+34 스페인</option>
              <option value="421">+421 슬로바키아</option>
              <option value="386">+386 슬로베니아</option>
              <option value="963">+963 시리아</option>
              <option value="232">+232 시에라리온</option>
              <option value="65">+65 싱가포르</option>
              <option value="971">+971 아랍에미리트</option>
              <option value="374">+374 아르메니아</option>
              <option value="54">+54 아르헨티나</option>
              <option value="1684">+1 684 아메리칸사모아</option>
              <option value="354">+354 아이슬란드</option>
              <option value="509">+509 아이티</option>
              <option value="353">+353 아일랜드</option>
              <option value="994">+994 아제르바이잔</option>
              <option value="93">+93 아프가니스탄</option>
              <option value="376">+376 안도라</option>
              <option value="355">+355 알바니아</option>
              <option value="213">+213 알제리</option>
              <option value="244">+244 앙골라</option>
              <option value="251">+251 에디오피아</option>
              <option value="291">+291 에리트레아</option>
              <option value="372">+372 에스토니아</option>
              <option value="593">+593 에콰도르</option>
              <option value="503">+503 엘살바도르</option>
              <option value="44">+44 영국</option>
              <option value="290">+290 영국령세인트헬레나</option>
              <option value="246">+246 영국령인도양지역</option>
              <option value="350">+350 영국령지브롤터</option>
              <option value="500">+500 영국령포클랜드제도</option>
              <option value="967">+967 예멘</option>
              <option value="968">+968 오만</option>
              <option value="43">+43 오스트리아</option>
              <option value="504">+504 온두라스</option>
              <option value="962">+962 요르단</option>
              <option value="256">+256 우간다</option>
              <option value="598">+598 우루과이</option>
              <option value="998">+998 우즈베키스탄</option>
              <option value="380">+380 우크라이나</option>
              <option value="964">+964 이라크</option>
              <option value="98">+98 이란</option>
              <option value="972">+972 이스라엘</option>
              <option value="20">+20 이집트</option>
              <option value="39">+39 이탈리아</option>
              <option value="91">+91 인도</option>
              <option value="62">+62 인도네시아</option>
              <option value="81">+81 일본</option>
              <option value="1876">+1 876 자메이카</option>
              <option value="260">+260 잠비아</option>
              <option value="240">+240 적도기니</option>
              <option value="995">+995 조지아</option>
              <option value="86">+86 중국</option>
              <option value="236">+236 중앙아프리카공화국</option>
              <option value="253">+253 지부티</option>
              <option value="263">+263 짐바브웨</option>
              <option value="235">+235 차드</option>
              <option value="420">+420 체코</option>
              <option value="56">+56 칠레</option>
              <option value="237">+237 카메룬</option>
              <option value="238">+238 카보베르데</option>
              <option value="974">+974 카타르</option>
              <option value="855">+855 캄보디아왕국</option>
              <option value="254">+254 케냐</option>
              <option value="269">+269 코모로,마요트</option>
              <option value="506">+506 코스타리카</option>
              <option value="225">+225 코트디부아르</option>
              <option value="57">+57 콜롬비아</option>
              <option value="242">+242 콩고</option>
              <option value="243">+243 콩고민주공화국</option>
              <option value="53">+53 쿠바</option>
              <option value="965">+965 쿠웨이트</option>
              <option value="682">+682 쿡제도</option>
              <option value="385">+385 크로아티아</option>
              <option value="996">+996 키르기스스탄</option>
              <option value="686">+686 키리바시</option>
              <option value="357">+357 키프로스</option>
              <option value="886">+886 타이완</option>
              <option value="992">+992 타지키스탄</option>
              <option value="255">+255 탄자니아</option>
              <option value="66">+66 태국</option>
              <option value="90">+90 터키</option>
              <option value="228">+228 토고</option>
              <option value="676">+676 통가</option>
              <option value="993">+993 투르크메니스탄</option>
              <option value="216">+216 튀니지</option>
              <option value="1868">+1 868 트리니다드토바고</option>
              <option value="507">+507 파나마</option>
              <option value="595">+595 파라과이</option>
              <option value="92">+92 파키스탄</option>
              <option value="675">+675 파푸아뉴기니</option>
              <option value="680">+680 팔라우</option>
              <option value="970">+970 팔레스타인</option>
              <option value="51">+51 페루</option>
              <option value="351">+351 포르투갈</option>
              <option value="48">+48 폴란드</option>
              <option value="1787">+1 787 푸에르토리코</option>
              <option value="33">+33 프랑스</option>
              <option value="590">+590 프랑스령과들루프</option>
              <option value="594">+594 프랑스령기아나</option>
              <option value="687">+687 프랑스령뉴칼레도니아</option>
              <option value="262">+262 프랑스령레위니옹</option>
              <option value="596">+596 프랑스령마르티니크</option>
              <option value="508">+508 프랑스령생피에르미클롱</option>
              <option value="681">+681 프랑스령월리스푸투나제</option>
              <option value="689">+689 프랑스령폴리네시아</option>
              <option value="679">+679 피지</option>
              <option value="358">+358 핀란드</option>
              <option value="63">+63 필리핀</option>
              <option value="36">+36 헝가리</option>
              <option value="61">+61 호주</option>
              <option value="852">+852 홍콩</option>
            </select>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              title="Cell Phone Number ex) 010-000-0000"
              :placeholder="$t('account.cellphone')"
              class="input_phone bg-white"
              v-model="user.mobileTelNo"
            />
            <input
              type="text"
              id="certiNumber"
              name="certiNumber"
              title="Certification Number"
              class="bg-white"
              :placeholder="$t('account.certificationnumber')"
              v-model="user.certiNumber"
            />
            <a href="#" class="small_submit_bt middle" @click="sendSMS">{{
              $t("login.authNumber")
            }}</a>
            <a href="#" class="small_submit_bt bottom" @click="checkCerti">{{
              $t("login.auth")
            }}</a>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import { sendSMS, checkCerti } from "@/api/user";
import { validatePhone } from "@/utils/validation";

export default {
  data() {
    return {
      user: {
        loginId: "",
        mobileTelNo: "",
        mobileTelCountry: "82",
        certiNumber: "",
      },
      isSendSms: false,
    };
  },
  methods: {
    async sendSMS() {
      if (!validatePhone(this.user.mobileTelNo)) {
        alert(this.$t("account.validatecellphone"));
        return;
      }
      try {
        const response = await sendSMS(this.user);
        this.isSendSms = response.data.status;
        if (this.isSendSms) {
          alert(this.$t("account.verifivationsuccess"));
        } else {
          alert(this.$t("account.verifivationfail"));
        }
      } catch (error) {
        //                console.log(error);
      }
    },
    async checkCerti() {
      if (!this.isSendSms) {
        alert(this.$t("account.nosendverify"));
        return;
      }
      try {
        const response = await checkCerti(this.user);
        if (response.data.status) {
          alert(this.$t("account.verifysuccess"));
        } else {
          alert(this.$t("account.verifyfail"));
        }
      } catch (error) {
        //                console.log(error);
      }
    },
  },
  mounted() {},
};
</script>

<style></style>
